/**
 * SidebarBrand — nagłówek marki w sidebarze. W skórce `antd` (praca UI/UX 2026-09)
 * pokazuje brand „Workflow365 / Obieg dokumentów" (oficjalne logo SVG dostarczone przez
 * Eugenię, `assets/workflow365-logo.svg`); w pozostałych skórkach — dotychczasowy tytuł +
 * podtytuł. Zmiana brandu na „Workflow365" to świadoma decyzja produktowa (2026-09), na
 * razie tylko w skórce antd.
 */
import workflow365Logo from '@/assets/workflow365-logo.svg';
import { useSidebarSkin } from '@/hooks/useSidebarSkin';

export function SidebarBrand({ title, subtitle }: { title: string; subtitle: string }) {
  const skin = useSidebarSkin();

  if (skin === 'antd') {
    return (
      <div className="flex flex-col gap-1">
        <img src={workflow365Logo} alt="Workflow365" className="h-5 w-auto" />
        <div className="text-xs font-semibold leading-tight text-[#1755a6]">Obieg dokumentów</div>
      </div>
    );
  }

  return (
    <div>
      <h1 className="text-lg font-semibold text-text-primary">{title}</h1>
      <p className="mt-0.5 text-xs text-text-muted">{subtitle}</p>
    </div>
  );
}

export default SidebarBrand;
